import type { UI } from '@/v2/types';
import React from 'react';
import styled from '@emotion/styled';
import { Flex, Hide, Image } from '@qga/roo-ui/components';

import CollapsiblePackageSection, {
  Heading,
} from '@shared/v2/components/CollapsiblePackageSection';
import { SkeletonProvider } from '@shared/v2/components/Skeleton';

import { hotelBed } from '@/v2/components/icons';
import MainRooms from '@/v2/components/pages/PackageView/components/RoomOptions/components/MainRooms';
import UnavailableWarning from '@/v2/components/pages/PackageView/components/UnavailableWarning';
import { useOtherPackageModal } from '@/v2/components/pages/PackageView/contexts/OtherPackageModalContext';
import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import OtherPackageModal from '../OtherPackageModal';
import OtherRooms from './components/OtherRooms';
import SearchPanel from './components/SearchPanel';

export type RoomOptionsProps = {
  campaign: UI.Campaign | null;
};

const HeadingContainer = styled(Flex)`
  gap: 4px;
`;

const RoomOptions = ({ campaign }: RoomOptionsProps) => {
  const { isLoading, roomOptions } = useRoomOptionsData() || {};
  const { main, other } = roomOptions || {};
  const { closeOtherPackageModal, isOtherPackageModalOpen } =
    useOtherPackageModal();

  return (
    <SkeletonProvider isLoading={isLoading}>
      <CollapsiblePackageSection
        isOpen
        showButton={false}
        icon={<Image size="48px" alt="" src={hotelBed} />}
        headerContent={
          <HeadingContainer
            flexDirection="column"
            justifyContent="space-between"
          >
            <Heading isBig>Room options</Heading>
            <Heading>
              Select travel dates and travellers to see package pricing
            </Heading>
          </HeadingContainer>
        }
        sectionContent={
          <Flex alignItems="flex-start" pt="2" gap="1.5rem">
            <Flex flex="1" flexDirection="column">
              <Hide md lg>
                <UnavailableWarning mb="4" />
              </Hide>
              <MainRooms roomOptions={main} />
              <OtherRooms
                roomOptions={other}
                roomIndexOffset={main?.length || 0}
              />
            </Flex>
            <SearchPanel campaign={campaign} />
          </Flex>
        }
      />
      <OtherPackageModal
        isOpen={isOtherPackageModalOpen}
        onClose={closeOtherPackageModal}
      />
    </SkeletonProvider>
  );
};

export default RoomOptions;
